"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RULES = void 0;
exports.RULES = {
    CLIENT_DOUBLE_BOOK: {
        code: 'CLIENT_DOUBLE_BOOK',
        severity: 'HARD',
        description: 'Client is already scheduled at this time',
    },
    PROVIDER_DOUBLE_BOOK: {
        code: 'PROVIDER_DOUBLE_BOOK',
        severity: 'HARD',
        description: 'Provider is already scheduled at this time',
    },
    PROVIDER_ROLE_MISMATCH: {
        code: 'PROVIDER_ROLE_MISMATCH',
        severity: 'HARD',
        description: 'Provider role cannot deliver this service',
    },
    PLACE_NOT_ALLOWED: {
        code: 'PLACE_NOT_ALLOWED',
        severity: 'HARD',
        description: 'Place of service not allowed for this service type',
    },
    OUTSIDE_PROVIDER_AVAILABILITY: {
        code: 'OUTSIDE_PROVIDER_AVAILABILITY',
        severity: 'HARD',
        description: 'Appointment falls outside provider weekly availability',
    },
    CLIENT_GROUP_CONFLICT: {
        code: 'CLIENT_GROUP_CONFLICT',
        severity: 'HARD',
        description: 'Client has a required group at this time',
    },
    GROUP_OVER_CAPACITY: {
        code: 'GROUP_OVER_CAPACITY',
        severity: 'POLICY',
        description: 'Group session is at or over maximum capacity',
    },
    PROVIDER_OVER_WEEKLY_CAP: {
        code: 'PROVIDER_OVER_WEEKLY_CAP',
        severity: 'POLICY',
        description: 'Provider exceeds configured maximum direct-service hours per week',
    },
    GROUP_UNDERSTAFFED: {
        code: 'GROUP_UNDERSTAFFED',
        severity: 'POLICY',
        description: 'Group session has fewer staff than minimum required',
    },
    NOT_PREFERRED_DAY: {
        code: 'NOT_PREFERRED_DAY',
        severity: 'SOFT',
        description: 'Appointment is outside the client preferred days',
    },
    BUNDLE_BROKEN: {
        code: 'BUNDLE_BROKEN',
        severity: 'SOFT',
        description: 'Service that should be bundled was placed on a different day',
    },
    PROVIDER_HIGH_UTILIZATION: {
        code: 'PROVIDER_HIGH_UTILIZATION',
        severity: 'SOFT',
        description: 'Provider utilization exceeds the soft cap',
    },
    TELEHEALTH_NOT_ALLOWED: {
        code: 'TELEHEALTH_NOT_ALLOWED',
        severity: 'HARD',
        description: 'Telehealth delivery not allowed for this service, resource, or client',
    },
    MISSING_REQUIRED_GROUP_RESOURCE: {
        code: 'MISSING_REQUIRED_GROUP_RESOURCE',
        severity: 'HARD',
        description: 'No active GROUP resource exists for a cohort-required service kind',
    },
};
//# sourceMappingURL=rules.js.map